export default __webpack_public_path__ + "static/k1-4badd21ccabb3ba57a1e5e8b6da9c6f3.png";